export default __webpack_public_path__ + "static/profile-9feec139a82dca0c1d8e2b06dc65d012.webp";